import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {
  closeModalByNameAction,
  PlainModals,
} from 'store/modules/modals/modals.reducer';

import {
  StyledTableBodyCell,
  StyledTableHeaderCell,
} from 'components/table/styles';
import {
  useGetModalMetaData,
  useIsPlainModalOpenSelector,
} from 'store/modules/modals/modals.selector';
import { ModalContainer } from 'components/modals/modal-container/modal-container';
import { FontSizes } from 'constants/font-sizes';
import { fontSecondary } from 'constants/font-family';
import { Colors } from 'constants/colors';
import { ReactComponent as ExternalIcon } from 'assets/icons/external.svg';
import { paths } from 'constants/routes';
import { MISSING_MODAL_NAME_LINK } from 'constants/test-ids';
import { setIdentitiesDetailsTab } from 'store/modules/identities/identities.reducer';
import { useSearchParams } from 'react-router-dom';

export const MissingModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') as string;
  const metaData = useGetModalMetaData();
  //@ts-ignore
  const members: MissingMember[] = metaData?.members;
  const isOpenModal = useIsPlainModalOpenSelector(
    PlainModals.MISSING_USERS_MODAL,
  );

  const handleCloseModal = () => {
    dispatch(closeModalByNameAction(PlainModals.MISSING_USERS_MODAL));
  };

  return (
    <ModalContainer
      isOpenModal={isOpenModal}
      title="Members"
      handleCloseModal={handleCloseModal}
      modalWidth="700px"
      modalHeight="400px"
    >
      <TableContainer
        sx={{
          marginTop: '15px',
          maxHeight: '750px',
          border: `1px solid ${Colors.tableBorder}`,
        }}
      >
        <Table
          stickyHeader
          sx={{ minWidth: '550px', backgroundColor: 'transparent' }}
          size="small"
        >
          <TableHead sx={{ height: '42px' }}>
            <TableRow>
              <StyledTableHeaderCell align="left">
                Members
              </StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          {members?.map((item, index) => (
            <TableRow
              key={index}
              sx={{
                '&.MuiTableRow-hover:hover': {
                  backgroundColor: Colors.tableBorder,
                },
                '&:nth-of-type(odd)': {
                  backgroundColor: Colors.white,
                },
                '&:nth-of-type(even)': {
                  backgroundColor: Colors.tableCell,
                },
              }}
            >
              <StyledTableBodyCell sx={{ borderBottom: '0px' }}>
                <Typography
                  onClick={() => {
                    dispatch(setIdentitiesDetailsTab(0));
                    navigate(
                      `${paths.identityDetails}?user=${item.login}&source=${
                        item?.source || item?.scm_source || source
                      }`,
                    );
                    handleCloseModal();
                  }}
                  sx={{
                    fontSize: FontSizes.fontSize14,
                    fontFamily: fontSecondary,
                    color: Colors.binge,
                    textDecoration: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                  data-testid={MISSING_MODAL_NAME_LINK}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {item.name || item.login}
                    <ExternalIcon style={{ marginLeft: '10px' }} />
                  </Box>
                </Typography>
              </StyledTableBodyCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </ModalContainer>
  );
};
